import {
  CartErrorEvent,
  CartLinesUpdateEvent,
} from '@shopify/events';

if (!window.zsCollectionCardActionsInitialized) {
  window.zsCollectionCardActionsInitialized = true;

  document.addEventListener('submit', async (event) => {
    const form =
      event.target instanceof HTMLFormElement
        ? event.target.closest(
            '[data-zs-collection-card-form]'
          )
        : null;

    if (!form) return;

    event.preventDefault();

    const button = form.querySelector(
      '[data-zs-collection-card-add]'
    );

    const buttonText = form.querySelector(
      '[data-zs-collection-card-button-text]'
    );

    const errorElement = form.querySelector(
      '[data-zs-collection-card-error]'
    );

    const variantInput = form.querySelector(
      'input[name="id"]'
    );

    const quantityInput = form.querySelector(
      'input[name="quantity"]'
    );

    if (
      !(button instanceof HTMLButtonElement) ||
      !(variantInput instanceof HTMLInputElement)
    ) {
      return;
    }

    if (button.disabled) return;

    const variantId = variantInput.value;

    const quantity = Math.max(
      1,
      Number(quantityInput?.value || 1)
    );

    const defaultLabel =
      button.dataset.defaultLabel || 'Add';

    const loadingLabel =
      button.dataset.loadingLabel || 'Adding…';

    const addedLabel =
      button.dataset.addedLabel || 'Added';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-added');

    if (buttonText) {
      buttonText.textContent = loadingLabel;
    }

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    const sectionIds = new Set([
      'cart-drawer-section',
    ]);

    document
      .querySelectorAll('cart-items-component')
      .forEach((component) => {
        if (
          component instanceof HTMLElement &&
          component.dataset.sectionId
        ) {
          sectionIds.add(component.dataset.sectionId);
        }
      });

    const deferredEventPromise =
      CartLinesUpdateEvent.createPromise();

    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'collection',
        lines: [
          {
            merchandiseId: variantId,
            quantity,
          },
        ],
        promise: deferredEventPromise.promise,
      })
    );

    try {
      const rootUrl =
        window.Shopify?.routes?.root || '/';

      const addResponse = await fetch(
        `${rootUrl}cart/add.js`,
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity,
              },
            ],
            sections: Array.from(sectionIds).join(','),
            sections_url:
              window.location.pathname +
              window.location.search,
          }),
        }
      );

      const addResult = await addResponse.json();

      if (!addResponse.ok || addResult.status) {
        throw new Error(
          addResult.description ||
            addResult.message ||
            'This product could not be added.'
        );
      }

      const cartResponse = await fetch(
        `${rootUrl}cart.js`,
        {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (!cartResponse.ok) {
        throw new Error(
          'The cart could not be refreshed.'
        );
      }

      const ajaxCart = await cartResponse.json();

      button.classList.add('is-added');

      if (buttonText) {
        buttonText.textContent = addedLabel;
      }

      deferredEventPromise.resolve({
        cart:
          CartLinesUpdateEvent.createCartFromAjaxResponse(
            ajaxCart
          ),
        detail: {
          items: ajaxCart.items,
          itemCount: quantity,
          productId: form.dataset.productId,
          sections: addResult.sections,
          source: 'zs-collection-card',
          sourceId:
            form.dataset.productId || variantId,
          didError: false,
        },
      });

      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-added');

        if (buttonText) {
          buttonText.textContent = defaultLabel;
        }
      }, 1400);
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : 'This product could not be added.';

      deferredEventPromise.reject(
        error instanceof Error
          ? error
          : new Error(message)
      );

      form.dispatchEvent(
        new CartErrorEvent({
          error: message,
          code: 'INVALID',
        })
      );

      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-added');

      if (buttonText) {
        buttonText.textContent = defaultLabel;
      }

      if (errorElement) {
        errorElement.textContent = message;
        errorElement.hidden = false;
      }
    }
  });
}